import { Fragment, ReactNode } from "react";
import { Menu as HeadlessMenu, Transition } from "@headlessui/react";
import { ThreeDotsVerticalIcon } from "@talladega/icons";
import classNames from "classnames";
import { Button, ButtonProps } from "../Button";

export interface MenuDropdownItem {
  name: string;
  icon?: React.ElementType;
  onClick: () => void;
  disabled?: boolean;
}

type Props = {
  position?: "left" | "right";
  menus: MenuDropdownItem[];
  button?: ButtonProps;
  renderMenus?: (menus: MenuDropdownItem[]) => ReactNode[];
};

export const MenuDropdown = ({
  position = "right",
  menus,
  button,
  renderMenus,
}: Props) => {
  return (
    <HeadlessMenu>
      <div className="relative">
        <HeadlessMenu.Button as={Fragment}>
          <Button
            fill="filled"
            buttonStyle="tertiary"
            spacing="tight-hug"
            className="border border-secondary rounded-lg w-[40px] h-[40px] bg-secondary shadow-skeumorphic"
            {...button}
          >
            <ThreeDotsVerticalIcon />
          </Button>
        </HeadlessMenu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <HeadlessMenu.Items
            className={classNames(
              "absolute mt-2 rounded-md bg-white shadow-elevation-03 z-30 ring-1 ring-black ring-opacity-5 focus:outline-none flex flex-col whitespace-nowrap",
              {
                "left-0": position === "left",
                "right-0": position === "right",
              }
            )}
          >
            <div className="flex flex-col">
              {renderMenus
                ? renderMenus(menus).map((m, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <HeadlessMenu.Item key={i}>{m}</HeadlessMenu.Item>
                  ))
                : menus.map((m) => {
                    return (
                      <HeadlessMenu.Item key={m.name}>
                        {() => (
                          <Button
                            fill="link"
                            buttonStyle="borderless"
                            onClick={m.onClick}
                            className="hover:bg-primary-hover"
                            disabled={m.disabled}
                          >
                            {m.name}
                          </Button>
                        )}
                      </HeadlessMenu.Item>
                    );
                  })}
            </div>
          </HeadlessMenu.Items>
        </Transition>
      </div>
    </HeadlessMenu>
  );
};

export default {};
